import { UserInfo } from '../types';
import {
  readBrowserStorageItem,
  removeBrowserStorageItem,
  writeBrowserStorageItem,
} from './browserStorage';

export const AUTH_USER_KEY = 'loan_auth_user';
export const AUTH_EXPIRES_AT_KEY = 'loan_auth_expires_at';
export const AUTH_LOGIN_MARK_KEY = 'loan_auth_login_mark';
const AUTH_TTL_MS = 12 * 60 * 60 * 1000;

// Client only stores lightweight login markers and profile cache.
// Real auth session is held in HttpOnly cookie on server side.
const getItem = (key: string) => readBrowserStorageItem(key);

const setItem = (key: string, value: string) => {
  writeBrowserStorageItem(key, value);
};

const removeItem = (key: string) => {
  removeBrowserStorageItem(key);
};

const getAuthExpiresAt = () => {
  const raw = getItem(AUTH_EXPIRES_AT_KEY);
  if (!raw) return 0;
  const value = Number(raw);
  return Number.isFinite(value) ? value : 0;
};

const isExpired = () => {
  const expiresAt = getAuthExpiresAt();
  if (!expiresAt) return true;
  return Date.now() >= expiresAt;
};

export const isAuthenticated = () => {
  const mark = getItem(AUTH_LOGIN_MARK_KEY);
  if (!mark) return false;
  if (isExpired()) {
    clearAuth();
    return false;
  }
  return true;
};

export const saveAuth = (phone: string, expiresInSec?: number) => {
  const expiresAt = Date.now() + (expiresInSec ? expiresInSec * 1000 : AUTH_TTL_MS);
  setItem(AUTH_EXPIRES_AT_KEY, String(expiresAt));
  setItem(AUTH_LOGIN_MARK_KEY, '1');
};

export const getStoredUser = (): UserInfo | null => {
  const raw = getItem(AUTH_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as UserInfo;
  } catch {
    removeItem(AUTH_USER_KEY);
    return null;
  }
};

export const saveStoredUser = (user: UserInfo) => {
  setItem(AUTH_USER_KEY, JSON.stringify(user));
};

export const clearStoredUser = () => {
  removeItem(AUTH_USER_KEY);
};

export const clearAuth = () => {
  removeItem(AUTH_EXPIRES_AT_KEY);
  removeItem(AUTH_LOGIN_MARK_KEY);
  clearStoredUser();
};
